export class UpAssignationsUris {
  // Prefixes
  static AMO_PREFIX = 'amo:';
  static APPLICATION_PREFIX = UpAssignationsUris.AMO_PREFIX + 'Application_';
  static FEATURE_PREFIX = UpAssignationsUris.AMO_PREFIX + 'Feature_';

  // Application URI
  static UP_ASSIGNATIONS_V2 =
    UpAssignationsUris.APPLICATION_PREFIX + 'UPAssignationsV2';

  // Feature Tabs URIs
  static TRACKING_TABLE =
    UpAssignationsUris.FEATURE_PREFIX + 'LitigationsDashboard';
  static LITIGATIONS_HISTORY =
    UpAssignationsUris.FEATURE_PREFIX + 'LitigationsHistory';
  static LOGS = UpAssignationsUris.FEATURE_PREFIX + 'Logs';
  static NOTIFICATIONS = UpAssignationsUris.FEATURE_PREFIX + 'Notifications';
}
